import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { RootLayout } from '@/routes/RootLayout';
import { Home } from '@/routes/Home';
import { NotFound } from '@/routes/NotFound';

const Editor = lazy(() => import('@/routes/Editor').then((m) => ({ default: m.Editor })));
const Preview = lazy(() => import('@/routes/Preview').then((m) => ({ default: m.Preview })));
const Settings = lazy(() => import('@/routes/Settings').then((m) => ({ default: m.Settings })));
const Auth = lazy(() => import('@/routes/Auth').then((m) => ({ default: m.Auth })));

function withSuspense(node: React.ReactNode) {
  return <Suspense fallback={<div className="py-12 text-center">…</div>}>{node}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <Home /> },
      { path: 'editor', element: withSuspense(<Editor />) },
      { path: 'preview', element: withSuspense(<Preview />) },
      { path: 'settings', element: withSuspense(<Settings />) },
      { path: 'auth', element: withSuspense(<Auth />) },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
